import { Navigate, useParams } from 'react-router-dom';

/**
 * Editing an app lives in the Settings tab of the app page (roles, access,
 * clients and authorization settings share one tabbed workspace). This route is
 * kept so existing links keep working.
 */
export function ProductEditPage() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/products/${id}?tab=settings`} replace />;
}
